import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

import { GroupPricesService } from './../../../core/api/services/group-prices.service';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
    selector: 'group-price-select-search',
    templateUrl: './base/base-select-search-template.html',
    imports: [BaseSelectSearchModule]
})
export class GroupPriceSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  //#region properties
  @Input() isShowGroupPrice: boolean;
  //#endregion

  constructor(protected currentService: GroupPricesService) {
    super();
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'title';
    if (!this.label) this.label = 'common.groupPrice';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isShowGroupPrice']) this.getItems();
    super.ngOnChanges(changes);
  }

  getItemsApi() {
    if (!this.id) {
      this.items = [];
      this.isFetchData = true;
      this.initLoading = false;
      return;
    }

    this.currentService
      .groupPricesGetGroupPriceListByCategoryId({
        GroupPriceCategoryId: this.id,
      })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }
}
